import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Send } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!email.trim()) { setError('Email is required.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError('Enter a valid email address.'); return; }
    setError('');
    // Form is valid — handle reset here
  };

  const inputBase = "w-full bg-[#0F172A] border text-white rounded-xl pl-11 pr-4 py-3 focus:outline-none transition-all duration-300 shadow-inner";
  const inputOk = "border-slate-700/80 focus:border-[#2563EB] focus:ring-1 focus:ring-[#2563EB]/50";
  const inputErr = "border-red-500/60 focus:border-red-500/80 focus:ring-1 focus:ring-red-500/50";

  return (
    <div className="min-h-screen bg-[#0F172A] font-sans text-white  flex flex-col relative">
      
      {/* GLOBAL BACKGROUND GLOWS */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <img src="https://images.unsplash.com/photo-1612550761236-e813928f7271?auto=format&fit=crop&q=80&w=2400" alt="Background" className="w-full h-full object-cover opacity-[0.03] mix-blend-screen" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/80 via-[#0F172A]/95 to-[#0F172A]" />
        
        {/* Theme Orbs */}
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-[#2563EB]/15 rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[600px] h-[600px] bg-[#F43F5E]/10 rounded-full blur-[150px]" />
      </div>

      <div className="relative z-50">
        <Header />
      </div>

      <main className="flex-1 relative z-10 flex items-center justify-center p-6 min-h-[70vh]">
        <div className="w-full max-w-md bg-[#1E293B]/90 backdrop-blur-xl border border-slate-700/80 p-8 rounded-[2rem] shadow-2xl relative">
          
          <Link to="/login" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-[#2563EB] mb-8 transition-colors font-medium">
            <ArrowLeft className="w-4 h-4" /> Back to login
          </Link>

          <div className="mb-8 text-left">
            <h1 className="text-3xl font-extrabold mb-3 text-white">Reset Password</h1>
            <p className="text-slate-400 text-sm leading-relaxed">
              Enter the email associated with your <span className="text-[#2563EB] font-semibold">personalfinanceacademy</span> account and we'll send you a link to reset your password.
            </p>
          </div>

          <form className="space-y-6" onSubmit={handleSubmit} noValidate>
            <div>
              <label className="block text-sm font-semibold text-slate-300 mb-2 text-left">Email Address</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Mail className="w-5 h-5 text-slate-500" />
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`${inputBase} ${submitted && error ? inputErr : inputOk}`}
                  placeholder="investor@example.com"
                />
              </div>
              {submitted && error && <p className="text-red-400 text-xs mt-1.5 text-left">{error}</p>}
            </div>

            <button type="submit" className="w-full bg-[#2563EB] hover:bg-[#1d4ed8] text-white font-bold py-3.5 rounded-xl shadow-[0_0_20px_rgba(37,99,235,0.3)] hover:shadow-[0_0_25px_rgba(37,99,235,0.5)] transition-all flex items-center justify-center gap-2 group">
              Send Reset Link
              <Send className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </button>
          </form>
        </div>
      </main>

      <div className="relative mt-auto">
        <Footer />
      </div>
    </div>
  );
}
